angular.
module("dx.webapp.class").
controller("DxClassAddSingleStudentController", function ClassAddSingleStudentController(
	$timeout,
	$rootScope,
	$scope,

	validationService,
	dxApi,

	dxLocalize
) {
	"use strict";

	var self = this;

	// Single add
	self.studentEmail = "";
	self.studentAddFeedbackMessage = null;
	self.studentAddFeedbackClass = null;
	self.inProgress = false;
	self.validEmail = false;
	self.placeholderText = dxLocalize.get("Action.AddStudentWithEmail");

	$scope.$watch("vm.disabledStudentcodes", function updatePlaceholderText() {
		self.placeholderText = self.disabledStudentcodes ?
			dxLocalize.get("StudentSearch.Placeholder.CodeDisabled") :
			dxLocalize.get("StudentSearch.Placeholder");
	});

	self.addStudent = function addStudent() {
		if (self.inProgress) {
			return;
		}

		self.studentAddFeedbackMessage = null;
		self.studentAddFeedbackClass = null;

		self.inProgress = true;
		var req = [self.studentEmail];

		dxApi.v1.groups.addMembers(self.classId, req, [403, 404]).then(function success(response) {
			var data = response.data;
			if (data.added.length > 0) {
				self.studentAddFeedbackClass = "color-text-success";
				self.studentAddFeedbackMessage = dxLocalize.get("Feedback.Added.Entity", data.added[0].name || data.added[0].email);
			} else {
				self.studentAddFeedbackClass = "color-text-warning";
				self.studentAddFeedbackMessage = dxLocalize.get("Student.Notification.AlreadyAdded.Class", data.alreadyAdded[0].name || data.alreadyAdded[0].email);
			}

			self.studentEmail = "";
			self.inProgress = false;

			// Give time for a student to be added to a live group exam
			$timeout(function updateList() {
				self.loadClassCallback();
			}, self.liveView ? 2000 : 0);
		}, function fail(response) {
			self.studentAddFeedbackClass = "color-text-error";
			if (response.status === 404) {
				self.studentAddFeedbackMessage = dxLocalize.get("Student.Notification.DoesNotExist.Single", self.studentEmail);
			} else {
				self.studentAddFeedbackMessage = dxLocalize.get("Student.Notification.Error", self.studentEmail);
			}

			self.inProgress = false;
		});
	};

	self.onInputChange = function onInputChange() {
		studentSearch();
		self.validEmail = validationService.isEmailValid(self.studentEmail.trim());
		self.studentAddFeedbackMessage = "";
	};

	function validateInput() {
		self.validEmail = validationService.isEmailValid(self.studentEmail.trim());

		if (!self.studentEmail.length || self.validEmail) {
			self.studentAddFeedbackMessage = null;
			self.studentAddFeedbackClass = null;
		} else {
			self.studentAddFeedbackMessage = dxLocalize.get("InvalidEmail", self.studentEmail);
			self.studentAddFeedbackClass = "color-text-error";
		}
	}

	function studentSearch() {
		if (self.studentEmail === "") {
			self.searchSuggestions = null;
		} else {
			dxApi.v1.studentinfo.get(self.studentEmail, 0, self.disabledStudentcodes).then(success, error);
		}

		function success(response) {
			self.searchSuggestions = response.data;
		}
		function error() {
			$rootScope.$broadcast("notification:error", dxLocalize.get("StudentSearchUnavailable"));
		}
	}

	self.chooseSuggestion = function chooseSuggestion(index) {
		self.studentEmail = self.searchSuggestions.hits[index].student.email;
		self.searchSuggestions = null;
		validateInput();
	};
});
